"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicColumnSlideoutContent = void 0;
const showFormDialog_1 = require("@juvare/common-form-ui/showFormDialog");
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const JuvareTheme_1 = require("@juvare/common-web-ui/JuvareTheme");
const ModalSlideout_1 = require("@juvare/common-web-ui/ModalSlideout");
const SnackbarHelper_1 = require("@juvare/common-web-ui/SnackbarHelper");
const prepareAddDynamicColumnRequest_1 = require("../../../../../../ui/features/dynamic-columns/utils/prepareAddDynamicColumnRequest");
const hooks_1 = require("../../../../../../ui/hooks");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const DynamicColumnConfigProvider_1 = __importDefault(require("../../DynamicColumnConfigProvider"));
const dynamicColumnStatusMap_1 = require("../../dynamicColumnStatusMap");
const editDynamicColumnFormConfig_1 = require("../FormConfigs/editDynamicColumnFormConfig");
const Record_1 = require("./Record");
const DynamicColumnSlideoutContent = ({ dynamicColumn, onReload, onClearActiveRow, }) => {
    const statusLabelValuePairs = Object.entries(dynamicColumnStatusMap_1.dynamicColumnStatusMap).map(([key, value]) => ({
        label: value,
        value: key,
    }));
    const dynamicColumnConfigContext = react_1.default.useContext(DynamicColumnConfigProvider_1.default);
    const dynamicColumnClient = (0, hooks_1.useDynamicColumnClient)();
    function showEditDynamicColumnDialog(value) {
        (0, showFormDialog_1.showFormDialog)({
            title: 'Edit Custom Field',
            data: value,
            config: editDynamicColumnFormConfig_1.editDynamicColumnFormConfig,
            onSubmit: (data) => (0, DialogHelper_1.showProgressDialog)({
                title: 'Edit Custom Field',
                callback: (done) => {
                    dynamicColumnClient
                        .deleteColumn({ id: data.id })
                        .then(() => dynamicColumnClient.addColumn((0, prepareAddDynamicColumnRequest_1.prepareAddDynamicColumnRequest)(data, dynamicColumnConfigContext, true)))
                        .then(() => {
                        (0, SnackbarHelper_1.showAlertSnackbar)({
                            message: 'Field saved',
                            type: 'success',
                        });
                        onClearActiveRow();
                        onReload();
                    })
                        .catch(DialogHelper_1.handleErrorDialog)
                        .finally(() => done());
                },
            }),
        });
    }
    const columnStatus = statusLabelValuePairs.find((status) => status.value === dynamicColumn?.status);
    const columnHandler = dynamicColumnConfigContext.columnHandlers.find((handler) => handler.name === dynamicColumn?.metadata?.columnHandlerName);
    return (react_1.default.createElement(material_1.Box, { sx: { p: 2, borderTop: `1px solid ${JuvareTheme_1.themeColors.border.main}` } },
        react_1.default.createElement(ModalSlideout_1.ModalSlideoutContent, { ariaDescribeAllChildren: false },
            react_1.default.createElement(Record_1.Record, { title: columnStatus ? columnStatus.label : '', value: columnStatus ? columnStatus.value : '' }),
            react_1.default.createElement(Record_1.Record, { title: 'Label', value: dynamicColumn.metadata?.label }),
            react_1.default.createElement(Record_1.Record, { title: 'Entity', value: dynamicColumn.entity }),
            react_1.default.createElement(Record_1.Record, { title: 'Data Path', value: dynamicColumn.dataPath }),
            react_1.default.createElement(Record_1.Record, { title: 'Type', value: dynamicColumn.type }),
            react_1.default.createElement(Record_1.Record, { title: 'Handler', value: columnHandler ? columnHandler.label : '' }),
            react_1.default.createElement(Record_1.Record, { title: 'Show In Table', value: dynamicColumn.metadata?.showInTable === true ? 'Yes' : 'No' }),
            react_1.default.createElement(Record_1.Record, { title: 'Show In Filter', value: dynamicColumn.metadata?.showInFilters === true ? 'Yes' : 'No' }),
            react_1.default.createElement(material_1.Divider, null),
            react_1.default.createElement(material_1.Button, { sx: { mt: 2 }, color: 'primary', variant: 'outlined', onClick: () => showEditDynamicColumnDialog(dynamicColumn), disabled: dynamicColumn.status !== 'active' }, "Edit"))));
};
exports.DynamicColumnSlideoutContent = DynamicColumnSlideoutContent;
